import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

@Component({
    selector: 'app-report-template-delete-confirm-dialog',
    templateUrl: './report-template-delete-confirm-dialog.component.html',
    styleUrls: ['./report-template-delete-confirm-dialog.component.scss'],
    standalone: false
})
export class ReportTemplateDeleteConfirmDialogComponent {
  deleteReportTemplateFlg: boolean;

  constructor(
    private dialogRef: MatDialogRef<ReportTemplateDeleteConfirmDialogComponent, { result: boolean }>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  confirm(): void {
    this.dialogRef.close({ result: true });
  }
}
